export const classifyBookingResults = (results) => {
  const statuses = new Set((results || []).map((item) => item.status));
  if (statuses.size === 1 && statuses.has('confirmed')) return 'confirmed';
  if (statuses.size === 1 && statuses.has('pending')) return 'pending';
  return 'mixed';
};

export const appointmentStatusLabelKey = (status) => ({
  pending: 'appointment_workflow.status.pending_salon',
  proposal_pending: 'appointment_workflow.status.pending_client',
  proposal_expired: 'appointment_workflow.status.expired',
  confirmed: 'client_status.confirmed',
  cancelled: 'client_status.cancelled',
  completed: 'client_status.completed',
}[status] || status);

export const remainingProposalSeconds = (expiresAt, now = Date.now()) =>
  Math.max(0, Math.floor((new Date(expiresAt).getTime() - now) / 1000));
